import { render } from "./ItemListComponent.vue?vue&type=template&id=10e18a24"
import script from "./ItemListComponent.vue?vue&type=script&lang=js"
export * from "./ItemListComponent.vue?vue&type=script&lang=js"

import "./ItemListComponent.vue?vue&type=style&index=0&id=10e18a24&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__